import { b as _slicedToArray } from '../_rollupPluginBabelHelpers-b0164b33.js';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Bem from '../packages/honey-bem.js';
import { Injecss } from '../packages/injecss.js';
import { L as Label } from '../index-c4501d32.js';

var styles = {
raw: ".hcr-time-input-1-6-0{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;position:relative;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;width:100%}.hcr-time-input--error-1-6-0 .hcr-time-input__field-1-6-0{border-color:#ff5700}.hcr-time-input--disabled-1-6-0 .hcr-time-input__field-1-6-0{cursor:not-allowed;opacity:.5}@media (min-width:1200px){.hcr-time-input__label-1-6-0{width:100%}}.hcr-time-input__select-1-6-0{position:relative;-webkit-box-flex:1;-webkit-flex:1;-ms-flex:1;flex:1;min-width:72px}.hcr-time-input__select--error-1-6-0:before,.hcr-time-input__select--valid-1-6-0:before{display:inline-block;width:24px;height:24px;content:\"\";vertical-align:middle;position:absolute;top:10px;right:49px;z-index:1}@media (min-width:1200px){.hcr-time-input__select--error-1-6-0:before,.hcr-time-input__select--valid-1-6-0:before{top:30px}}@media (min-width:1200px){.hcr-time-input__select--no-label-1-6-0:before{top:6px}}.hcr-time-input__select--error-1-6-0:before{background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 1000'%3E%3Cpath d='M500 90.9A409.1 409.1 0 10909.1 500 409.1 409.1 0 00500 90.9zm-28.2 150a28.2 28.2 0 0156.4 0v373.6a28.2 28.2 0 11-56.4 0zM500 803.6a45.5 45.5 0 1145.5-45.4 45.5 45.5 0 01-45.5 45.4z' fill='rgba(255, 87, 0, 0.99)'/%3E%3C/svg%3E\") no-repeat 50%}.hcr-time-input__select--valid-1-6-0:before{background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 1000'%3E%3Cpath d='M500 90.9A409.1 409.1 0 10909.1 500 409.1 409.1 0 00500 90.9zm257.3 276.4L460 664.5a23.6 23.6 0 01-15.9 6.4 22.7 22.7 0 01-15.9-6.4L242.7 479.1a22.3 22.3 0 010-31.4 21.8 21.8 0 0131.8 0l169.6 169.1 283.2-281.3a22.3 22.3 0 1131.8 31.8z' fill='rgba(115, 215, 0, 0.99)'/%3E%3C/svg%3E\") no-repeat 50%}.hcr-time-input__select-1-6-0:after{display:inline-block;width:24px;height:24px;content:\"\";vertical-align:middle;background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 1000'%3E%3Cpath d='M236.4 365.9a28.2 28.2 0 0140.4 0l216.4 216.4a8.2 8.2 0 0013.6 0l216.4-216.4a28.6 28.6 0 0140.4 40.5L545.5 622.7a66.4 66.4 0 01-45.5 19.6 66.4 66.4 0 01-45.5-19.6L236.4 406.4a28.2 28.2 0 010-40.5z' fill='rgba(139, 139, 139, 0.99)'/%3E%3C/svg%3E\") no-repeat 50%;position:absolute;top:10px;right:12px;pointer-events:none}@media (min-width:1200px){.hcr-time-input__select-1-6-0:after{top:30px}}.hcr-time-input__select--valid-1-6-0 .hcr-time-input__select__field-1-6-0{padding-right:80px}.hcr-time-input__select--error-1-6-0 .hcr-time-input__select__field-1-6-0{padding-right:80px;border:1px solid #ff5700}.hcr-time-input__select--active-1-6-0 .hcr-time-input__select__field-1-6-0{border:1px solid #757575;outline:none}.hcr-time-input__select--disabled-1-6-0 .hcr-time-input__select__field-1-6-0{cursor:not-allowed;opacity:.5}@media (min-width:1200px){.hcr-time-input__select-1-6-0:after{top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}}.hcr-time-input__field-1-6-0{font-family:Roboto Condensed,Arial,sans-serif;font-size:16px;font-weight:300;position:relative;width:100%;height:44px;border:1px solid #c8c8c8;border-radius:5px;background-color:#fff;color:#444;line-height:1.375em;text-overflow:ellipsis;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:transparent;padding:0 36px 0 12px;border-radius:0}@media (min-width:1200px){.hcr-time-input__field-1-6-0{height:36px}}.hcr-time-input__field-1-6-0::-webkit-input-placeholder{color:#757575;font-style:italic}.hcr-time-input__field-1-6-0::-moz-placeholder{color:#757575;font-style:italic}.hcr-time-input__field-1-6-0:-ms-input-placeholder{color:#757575;font-style:italic}.hcr-time-input__field-1-6-0::-ms-input-placeholder{color:#757575;font-style:italic}.hcr-time-input__field-1-6-0::placeholder{color:#757575;font-style:italic}.hcr-time-input__field-1-6-0:active,.hcr-time-input__field-1-6-0:focus,.hcr-time-input__field-1-6-0:hover{outline:0}.hcr-time-input__field-1-6-0::-ms-expand{display:none}.hcr-time-input__field-1-6-0:focus{border:1px solid #757575;outline:none}.hcr-time-input__field-1-6-0[disabled]{cursor:not-allowed;opacity:.5}.hcr-time-input__select-1-6-0:first-of-type .hcr-time-input__field-1-6-0{margin-left:0;border-radius:5px 0 0 5px}.hcr-time-input__select-1-6-0:last-of-type .hcr-time-input__field-1-6-0{border-radius:0 5px 5px 0}.hcr-time-input__select-1-6-0:only-of-type .hcr-time-input__field-1-6-0{border-radius:5px}.hcr-time-input__info-1-6-0{color:#444;font-size:14px;font-weight:300;line-height:17px;display:block;width:100%;padding-top:3px}.hcr-time-input--error-1-6-0 .hcr-time-input__info-1-6-0{color:#c64300}",
map:{"hcr-time-input":"hcr-time-input-1-6-0","hcr-time-input--error":"hcr-time-input--error-1-6-0","hcr-time-input__field":"hcr-time-input__field-1-6-0","hcr-time-input--disabled":"hcr-time-input--disabled-1-6-0","hcr-time-input__label":"hcr-time-input__label-1-6-0","hcr-time-input__select":"hcr-time-input__select-1-6-0","hcr-time-input__select--error":"hcr-time-input__select--error-1-6-0","hcr-time-input__select--valid":"hcr-time-input__select--valid-1-6-0","hcr-time-input__select--no-label":"hcr-time-input__select--no-label-1-6-0","hcr-time-input__select__field":"hcr-time-input__select__field-1-6-0","hcr-time-input__select--active":"hcr-time-input__select--active-1-6-0","hcr-time-input__select--disabled":"hcr-time-input__select--disabled-1-6-0","hcr-time-input__info":"hcr-time-input__info-1-6-0"}};

var TimeInputSelect = function TimeInputSelect(_ref) {
  var ariaLabel = _ref.ariaLabel,
      bem = _ref.bem,
      disabled = _ref.disabled,
      extraClasses = _ref.extraClasses,
      onChange = _ref.onChange,
      options = _ref.options,
      value = _ref.value,
      values = _ref.values;
  return React.createElement("div", {
    className: bem.e('select')
  }, React.createElement("select", {
    "aria-label": ariaLabel,
    disabled: disabled,
    className: bem.e('field', false, extraClasses),
    onChange: onChange,
    value: value
  }, options.map(function (option, index) {
    return React.createElement("option", {
      key: option,
      value: values[index]
    }, option);
  })));
};
TimeInputSelect.defaultProps = {
  ariaLabel: null,
  disabled: false
};
TimeInputSelect.propTypes = {
  ariaLabel: PropTypes.string,
  bem: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  extraClasses: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  value: PropTypes.string.isRequired,
  values: PropTypes.array.isRequired
};

var TIME_SEPARATOR = ':';
/**
 * Generates object with time options used to assemble time select boxes of different kind
 * @param options {array} - time strings in 24 hour format with ':' separator, e.g. '14:30'
 * @param showAmPm {boolean} - indicates resulting data format 12 or 24 hours
 * @param suffixText {array} - array containing AM/PM suffixes,
 * useful for providing custom ones, defaults to ['AM', 'PM']
 * @return {object} - resulting time object with the following structure:
 *                    {hours: [], minutes: [], options: [], optionsAmPm: []}
 *                    containing provided options in different formats
 * */

var generateTimeOptions = function generateTimeOptions(options, showAmPm, suffixText) {
  // defining return object structure
  var timeObj = {
    hours: [],
    // hours options, used for both values and option texts
    minutes: [],
    // minute options, used for both values and option texts
    options: [],
    // option text for single selects
    values: [] // option values for single select layout

  };

  var compareNumbers = function compareNumbers(a, b) {
    return a - b;
  };

  var uniqueItemsFilter = function uniqueItemsFilter(item, index, array) {
    return array.indexOf(item) === index;
  }; // collecting hours and minutes separately


  var hours = options.map(function (option) {
    return option.split(TIME_SEPARATOR)[0];
  });
  var minutes = options.map(function (option) {
    return option.split(TIME_SEPARATOR)[1];
  }); // making sure all the options are unique and sorted

  timeObj.options = options.filter(uniqueItemsFilter).sort(); // storing passed option values to use for single selects

  timeObj.values = options.filter(uniqueItemsFilter).sort(); // extracting hours and minutes to use for multiple select layouts

  timeObj.hours = hours.filter(uniqueItemsFilter).sort(compareNumbers);
  timeObj.minutes = minutes.filter(uniqueItemsFilter).sort(compareNumbers); // populate with 12 format options if needed

  if (showAmPm) {
    // creating option array in 12 hour format
    var optionsAmPm = options.map(function (option) {
      var _option$split = option.split(TIME_SEPARATOR),
          _option$split2 = _slicedToArray(_option$split, 2),
          optHours = _option$split2[0],
          optMinute = _option$split2[1];

      var optionHourAmPm = optHours > 12 ? optHours % 12 : optHours;
      var optionMinute = optMinute;
      var optionSuffix = optHours > 0 && optHours < 12 ? suffixText[0] : suffixText[1];
      return "".concat(optionHourAmPm, ":").concat(optionMinute, " ").concat(optionSuffix);
    }); // saving options for 12 hour format, unique and sorted

    timeObj.options = optionsAmPm.filter(uniqueItemsFilter).sort();
    var hoursAmPm = options.map(function (option) {
      var hourAmPm = option.split(TIME_SEPARATOR)[0] > 12 ? option.split(TIME_SEPARATOR)[0] % 12 : option.split(TIME_SEPARATOR)[0];
      return hourAmPm.toString();
    }); // making sure resulting items are unique and sorted

    timeObj.hours = hoursAmPm.filter(uniqueItemsFilter).sort(compareNumbers);
  }

  return timeObj;
};
/** converts given hour to 12h format, removes leading "0"
 * @param hour {string} - hours
 * @returns hourNormalized {string} - converted hours in 24h format */

var convertHourToAmPm = function convertHourToAmPm(hour) {
  var convertedValue = parseInt(hour > 12 ? hour % 12 : hour, 10);
  return convertedValue.toString();
};
/** converts time to 24 format depending on the given suffix value, performs "0" padding as well */

var convertTimeBySuffix = function convertTimeBySuffix(time, suffix) {
  var hours = time.split(TIME_SEPARATOR)[0];
  var minutes = time.split(TIME_SEPARATOR)[1];
  var hourNormalized;

  if (suffix === 'am') {
    hourNormalized = hours > 12 ? parseInt(hours, 10) - 12 : parseInt(hours, 10);
  }

  if (suffix === 'pm') {
    hourNormalized = hours < 12 ? parseInt(hours, 10) + 12 : parseInt(hours, 10);
  }

  hourNormalized = hourNormalized < 10 ? "0".concat(hourNormalized) : hourNormalized;
  return "".concat(hourNormalized, ":").concat(minutes);
};
/** Detects which 12 hour suffix corresponds the given 24 hour time
 * @param time {string} - time in 24 hour format, e.g. "15:00"
 * @param suffix {array} - array of suffixes
 * @return {string}
 * */

var getTimeSuffix = function getTimeSuffix(time, suffix) {
  return time.split(TIME_SEPARATOR)[0] > 0 && time.split(TIME_SEPARATOR)[0] < 12 ? suffix[0] : suffix[1];
};

var TimeInput = function TimeInput(_ref) {
  var ariaLabelHours = _ref.ariaLabelHours,
      ariaLabelMinutes = _ref.ariaLabelMinutes,
      ariaLabelSuffix = _ref.ariaLabelSuffix,
      defaultValue = _ref.defaultValue,
      disabled = _ref.disabled,
      extraClasses = _ref.extraClasses,
      info = _ref.info,
      label = _ref.label,
      onChange = _ref.onChange,
      options = _ref.options,
      requiredText = _ref.requiredText,
      showAmPm = _ref.showAmPm,
      showMinutes = _ref.showMinutes,
      suffixText = _ref.suffixText,
      valid = _ref.valid;
  var timeObj = generateTimeOptions(options, showAmPm, suffixText); // Array of values for AM/PM select,
  // this works in combination with suffixText array that holds presentational text

  var amPmValues = ['am', 'pm']; // defines base block class name for the input

  var bem = Bem('time-input', styles); // stores BEM class names, defines BEM modifiers

  var timeInputClassNames = bem.b({
    error: valid === false,
    disabled: disabled,
    'no-label': !label
  }); // if no value provided, use first item in the options list

  var initialValue = defaultValue || options[0]; // 12 hour format needs 12 hour option values, converting if the case

  var initialHourValue = !showAmPm ? initialValue.split(TIME_SEPARATOR)[0] : convertHourToAmPm(initialValue.split(TIME_SEPARATOR)[0]); // initialize state values

  var _useState = useState(initialValue),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = useState(initialHourValue),
      _useState4 = _slicedToArray(_useState3, 2),
      hourValue = _useState4[0],
      setHourValue = _useState4[1];

  var _useState5 = useState(initialValue.split(TIME_SEPARATOR)[1]),
      _useState6 = _slicedToArray(_useState5, 2),
      minutesValue = _useState6[0],
      setMinutesValue = _useState6[1];

  var _useState7 = useState(getTimeSuffix(initialValue, amPmValues)),
      _useState8 = _slicedToArray(_useState7, 2),
      suffixValue = _useState8[0],
      setSuffixValue = _useState8[1];

  useEffect(function () {
    // if no value provided, use first item in the options list
    var effectValue = defaultValue || options[0]; // 12 hour format needs 12 hour option values, converting if the case

    var effectHourValue = !showAmPm ? effectValue.split(TIME_SEPARATOR)[0] : convertHourToAmPm(effectValue.split(TIME_SEPARATOR)[0]);
    setValue(effectValue);
    setHourValue(effectHourValue);
    setMinutesValue(effectValue.split(TIME_SEPARATOR)[1]);
    setSuffixValue(getTimeSuffix(effectValue, amPmValues));
  }, [defaultValue]);
  /** Updates hours in value
   * @param hour {string} - hours ini 24h format
   * @returns newValue {string} - updated time value in 24h format
   */

  var updateValueHours = function updateValueHours(hour) {
    var arrValue = value.split(TIME_SEPARATOR);
    arrValue[0] = hour;
    var newValue = arrValue.join(TIME_SEPARATOR);
    setValue(newValue);
    return newValue;
  };
  /** Updates minutes in value
   * @param minutes {string} - minutes
   * @returns newValue {string} - updated time value in 24h format
  */


  var updateValueMinutes = function updateValueMinutes(minutes) {
    var arrValue = value.split(TIME_SEPARATOR);
    arrValue[1] = minutes;
    var newValue = arrValue.join(TIME_SEPARATOR);
    setValue(newValue);
    return newValue;
  };
  /** Updates value when AM/PM suffix selection changes
  * @param suffix {string} - time suffix value either "am" or "pm"
  * @returns newValue {string} - updated time value in 24h format
  */


  var updateValueBySuffix = function updateValueBySuffix(suffix) {
    var newValue = convertTimeBySuffix(value, suffix);
    setValue(newValue);
    return newValue;
  };
  /** Handles single select change, updating the state value
   * @param e {object} - Event obj of the mentioned select box
   * */


  var handleTimeChange = function handleTimeChange(e) {
    var newValue = e.target.value;
    setValue(newValue);
    onChange(newValue);
  };
  /** Handles hour select value change, updates state accordingly
   * @param e {object} - Event obj of an hour select box
   */


  var handleHourChange = function handleHourChange(e) {
    var hourSelectValue = e.target.value; // grab hours in 24 h format, converts to 24 h format if needed

    var hour = showAmPm && hourSelectValue < 12 && suffixValue === 'pm' ? parseInt(hourSelectValue, 10) + 12 : parseInt(hourSelectValue, 10);
    setHourValue(hourSelectValue);
    var newValue = updateValueHours(hour);
    onChange(newValue);
  };
  /** Handles minutes select value change, updates state accordingly
   * @param e {object} - Event obj of a minute select box
  */


  var handleMinutesChange = function handleMinutesChange(e) {
    var minutes = e.target.value;
    setMinutesValue(e.target.value);
    var newValue = updateValueMinutes(minutes);
    onChange(newValue);
  };
  /** Handles AM/PM suffix select value change, updates state accordingly
   * @param e {object} - Event obj of a AM/PM suffix select box
  */


  var handleAmPmChange = function handleAmPmChange(e) {
    setSuffixValue(e.target.value);
    var newValue = updateValueBySuffix(e.target.value);
    onChange(newValue);
  };

  return React.createElement("div", {
    className: timeInputClassNames
  }, React.createElement(Label, {
    extraClasses: bem.e('label'),
    requiredText: requiredText,
    text: label
  }), !showMinutes && React.createElement(TimeInputSelect, {
    ariaLabel: label,
    bem: bem,
    disabled: disabled,
    extraClasses: extraClasses,
    onChange: handleTimeChange,
    options: timeObj.options,
    value: value,
    values: timeObj.values
  }), showMinutes && React.createElement(TimeInputSelect, {
    ariaLabel: ariaLabelHours,
    bem: bem,
    disabled: disabled,
    extraClasses: extraClasses,
    onChange: handleHourChange,
    options: timeObj.hours,
    value: hourValue,
    values: timeObj.hours
  }), showMinutes && React.createElement(TimeInputSelect, {
    ariaLabel: ariaLabelMinutes,
    bem: bem,
    disabled: disabled,
    extraClasses: extraClasses,
    onChange: handleMinutesChange,
    options: timeObj.minutes,
    value: minutesValue,
    values: timeObj.minutes
  }), showAmPm && showMinutes && React.createElement(TimeInputSelect, {
    ariaLabel: ariaLabelSuffix,
    bem: bem,
    disabled: disabled,
    extraClasses: extraClasses,
    onChange: handleAmPmChange,
    options: suffixText,
    value: suffixValue,
    values: amPmValues
  }), info && React.createElement("span", {
    className: bem.e('info')
  }, info));
};
TimeInput.displayName = 'TimeInput';
TimeInput.defaultProps = {
  ariaLabelHours: null,
  ariaLabelMinutes: null,
  ariaLabelSuffix: null,
  disabled: null,
  extraClasses: '',
  info: null,
  requiredText: null,
  onChange: function onChange() {},
  showAmPm: false,
  showMinutes: false,
  suffixText: ['AM', 'PM'],
  valid: null,
  defaultValue: null
};
/** checks if supplied string value matches 24h time format, like 18:45
* @param props {object}
* @param propName {string}
* @param componentName {string}
*/

var timeFormat = function timeFormat(options, index, componentName) {
  if (!/^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/.test(options[index])) {
    return new Error("All options in component \"".concat(componentName, "\"\n      need to represent time in 24h format with \":\" separator\n      but \"").concat(options[index], "\" given"));
  }

  return null;
};

TimeInput.propTypes = {
  /** aria label text, to add to hour select */
  ariaLabelHours: PropTypes.string,

  /** aria label text, to add to minute select */
  ariaLabelMinutes: PropTypes.string,

  /** aria label text, to add to suffix select */
  ariaLabelSuffix: PropTypes.string,

  /** Injection in className */
  extraClasses: PropTypes.string,

  /** sets disabled state */
  disabled: PropTypes.bool,

  /** Provides extra information bellow the control */
  info: PropTypes.string,

  /** Provides label text, required */
  label: PropTypes.string.isRequired,

  /** Callback receiving the current time value in 24 hour format (see options) */
  onChange: PropTypes.func,

  /** Time options in 24 hour format, e.g. ['12:00', '13:00', '14:00'] */
  options: PropTypes.arrayOf(timeFormat).isRequired,

  /** Marks the element as required, adds specified text to label text */
  requiredText: PropTypes.string,

  /** Displays AM/PM select for 12 hour format */
  showAmPm: PropTypes.bool,

  /** Displays separate select element for minutes */
  showMinutes: PropTypes.bool,

  /** Custom AM/PM suffix texts, use for localization or similar needs */
  suffixText: PropTypes.array,

  /** Triggers visual validation output */
  valid: PropTypes.bool,

  /** Sets default time value */
  defaultValue: PropTypes.string
};
var timeInput = Injecss(TimeInput, styles);

export { timeInput as TimeInput };
